class VariantSelectors extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.variant-selector__button');
    this.dropdowns = this.querySelectorAll('.variant-selector__dropdown');
    this.variantSelect = this.querySelector('[data-variant-select]');
    this.productForm = document.querySelector(`#product-form-${this.dataset.section}`);
    this.options = this.querySelectorAll('.variant-selector__option');
    this.swatches = [];
    this.variantSelected = JSON.parse(this.querySelector('[data-selected-variant]').innerHTML)
    try {
      this.colorMappings = JSON.parse(this.dataset.colorMappings || '{}');
      this.normalizedColorMappings = Object.fromEntries(
        Object.entries(this.colorMappings).map(([key, value]) => [
          this.normalizeString(key),
          value
        ])
      );

      // this.setInitialColors();
    } catch (e) {
      console.error('Error parsing color mappings:', e);
      this.normalizedColorMappings = {};
    }

  }

  async connectedCallback() {
    this.setupEventListeners();
    await this.getAllSwatch()
    this.setupInitialState();
  }

  async getAllSwatch() {
    var hasNext = false;
    var cursor = null;
    do {
      if (cursor != null) {
        var result = await this.fetchSwatch(cursor);
      } else {
        var result = await this.fetchSwatch();
      }
      hasNext = result.metaobjects.pageInfo.hasNextPage;
      cursor = result.metaobjects.pageInfo.endCursor;
      this.swatches = [...this.swatches, ...result.metaobjects.nodes];
    } while (hasNext)
    this.options.forEach(option => {
      var value = option.dataset.value;
      var swatch = this.swatches.find(s => s.fields[1].value == value);
      if (swatch) {
        if (option.querySelector('.variant-selector__color') == null) {
          option.innerHTML = `<span class="variant-selector__color" data-color-value="${swatch.fields[0].value}" style="background-color: ${swatch.fields[0].value}"></span>${value}`
        }
      }
    })
  }

  async fetchSwatch(cursor = null) {
    var query = `{ metaobjects(type: "product_color_mapping", first: 50) { pageInfo { hasNextPage endCursor } nodes { handle fields { key value }}}}`;
    if (cursor != null) {
      query = `{ metaobjects(after: "${cursor}",type: "product_color_mapping", first: 50) { pageInfo { hasNextPage endCursor } nodes { handle fields { key value }}}}`;
    }
    return await fetch('https://woodone-shuei-prd.myshopify.com/api/2025-01/graphql.json', {
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '00e0c0894ba6406c5678ef4a26795fd4'
      },
      method: 'POST',
      body: JSON.stringify({
        query
      })
    }).then(res => res.json()).then(res => res.data)
  }

  setupInitialState() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || this.variantSelect?.value;

    if (variantId && this.variantSelect) {
      const option = Array.from(this.variantSelect.options).find(opt => opt.value === variantId);
      if (option) {
        this.variantSelect.value = variantId;
        const variantTitle = option.text;
        const variantValues = variantTitle.split(' / ');

        this.renderVariantSection(variantId);
      }
    }
  }

  normalizeString(str) {
    return str
      .replace(/[（）]/g, '')
      .replace(/[()]/g, '')
      .replace(/\s+/g, '')
      .trim();
  }

  getColorForValue(value) {
    const normalizedValue = this.normalizeString(value);
    return this.normalizedColorMappings[normalizedValue];
  }

  setInitialColors() {
    const colorElements = this.querySelectorAll('[data-color-value]');
    colorElements.forEach(colorElement => {
      const colorValue = colorElement.getAttribute('data-color-value');
      const color = this.getColorForValue(colorValue);
      if (color) {
        colorElement.style.backgroundColor = color;
      } else {
        colorElement.style.backgroundColor = 'transparent';
      }
    });

    this.buttons.forEach(button => {
      const activeColorElement = button.querySelector('[data-color]');
      if (activeColorElement) {
        const currentVariantColor = button.querySelector('[data-option-text]')?.textContent.trim();
        const color = this.getColorForValue(currentVariantColor);
        if (color) {
          activeColorElement.style.backgroundColor = color;
        } else {
          activeColorElement.style.backgroundColor = 'transparent';
        }
      }
    });
  }



  setupEventListeners() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const dropdown = button.nextElementSibling;
        const isOpen = dropdown.classList.contains('is-open');

        this.closeAllDropdowns();

        if (!isOpen) {
          dropdown.classList.add('is-open');
        }
      });
    });

    this.dropdowns.forEach((dropdown, index) => {
      const button = dropdown.previousElementSibling;
      const options = dropdown.querySelectorAll('.variant-selector__option');

      options.forEach(option => {
        option.addEventListener('click', (e) => {
          options.forEach(op => op.classList.remove('selected'))
          const selectedValue = option.getAttribute('data-value');
          const textElement = button.querySelector('[data-option-text]');
          const optionName = option.closest('.variant-selector__options').dataset.name;
          option.classList.add('selected');
          textElement.textContent = selectedValue;


          this.updateVariantSelection(index, selectedValue);
          var originSelect = document.querySelector('select[name="' + optionName + '"]')
          originSelect.querySelectorAll('option').forEach(o => {
            if (o.value == selectedValue) {
              o.setAttribute('selected', 'selected')
            } else {
              o.removeAttribute('selected')
            }
          })
          originSelect.value = selectedValue
          originSelect.dispatchEvent(new Event('change'))
          document.querySelector('variant-selects').dispatchEvent(new CustomEvent('change', {
            'detail': {
              target: originSelect
            }
          }))
          dropdown.classList.remove('is-open');
        });
      });
    });

    document.addEventListener('click', () => {
      this.closeAllDropdowns();
    });

  }

  closeAllDropdowns() {
    this.dropdowns.forEach(dropdown => {
      dropdown.classList.remove('is-open');
    });
  }

  updateVariantSelection(optionIndex, value) {
    const selections = Array.from(this.buttons).map(button =>
      button.querySelector('[data-option-text]').textContent.trim()
    );
    selections[optionIndex] = value;

    if (this.variantSelect) {
      const option = Array.from(this.variantSelect.options).find(option => {
        const variantTitle = option.text;
        const variantValues = variantTitle.split(' / ');
        const options_selected = Array.from(this.querySelectorAll('.variant-selector__option.selected')).map(op => op.dataset.value)
        let match = true;
        variantValues.forEach((val, i) => {
          if (i == optionIndex) {
            if (val != value) match = false
          } else {
            if (val != options_selected[i]) match = false
          }
        })
        return match;
      });

      if (option) {
        this.variantSelect.value = option.value;
        const variantInputs = document.querySelectorAll('input[name="id"]');
        variantInputs.forEach(input => {
          input.value = option.value;
        });

        const productForms = document.querySelectorAll('form[action*="/cart/add"]');
        productForms.forEach(form => {
          const currentAction = new URL(form.action, window.location.origin);
          if (currentAction.searchParams.has('variant')) {
            currentAction.searchParams.set('variant', option.value);
          }
          form.action = currentAction.toString();
        });

        const changeEvent = new CustomEvent('change', {
          bubbles: true,
          detail: {
            variant: {
              id: option.value,
              title: option.text,
              available: !option.disabled,
              optionValues: selections
            }
          }
        });
        this.variantSelect.dispatchEvent(changeEvent);

        if (history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({ path: url.href }, '', url.href);
        }

        this.renderVariantSection(option.value);
      }
    }
  }

  async renderVariantSection(variantId) {
    const productInfo = this.closest('product-info');
    if (!productInfo) return;

    const sectionId = productInfo.dataset.section;
    const productUrl = window.location.pathname;

    try {
      const response = await fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`);
      if (!response.ok) throw new Error(response.statusText);

      const html = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');

      this.updateVariantInfo(newDocument, sectionId);
      this.updateInventoryStatus(newDocument, sectionId);
      this.updateMediaGallery(variantId);

      this.dispatchVariantChangeEvent(newDocument, sectionId, variantId);

    } catch (error) {
      console.error('Error updating variant:', error);
    }
  }

  observeElementUpdate(selector, callback) {
    const targetNode = $(selector)[0];
    if (!targetNode) {
      console.log("Element not found");
      return;
    }
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          callback(); // Call the callback when HTML content changes
        }
      });
    });
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
    return observer;
  }

  updateVariantInfo(newDocument, sectionId) {
    // this.updateElement('Sku', newDocument, sectionId);
    this.updateElement('variant-title', newDocument, sectionId);
    this.updateElement('variant-barcode', newDocument, sectionId);
  }

  updateInventoryStatus(newDocument, sectionId) {
    this.updateElement('Inventory', newDocument, sectionId);
    this.updateElement('available', newDocument, sectionId);
  }

  updateElement(elementId, newDocument, sectionId) {
    const currentElement = document.getElementById(`${elementId}-${sectionId}`);
    const newElement = newDocument.getElementById(`${elementId}-${sectionId}`);

    if (currentElement && newElement) {
      currentElement.innerHTML = newElement.innerHTML;
      if (newElement.classList.contains('hidden')) {
        currentElement.classList.add('hidden');
      } else {
        currentElement.classList.remove('hidden');
      }
    }
  }

  updateMediaGallery() {
    if (this.variantSelected?.featured_media != null) {
      document.querySelector('.thumbnail-list__item[data-media-position="' + this.variantSelected?.featured_media.position + '"]').click()
    }
  }

  getSelectedVariantData(content) {
    const variantData = content.querySelector('[data-selected-variant]')?.innerHTML;
    try {
      return variantData ? JSON.parse(variantData) : null;
    } catch (e) {
      console.error('Error parsing variant data:', e);
      return null;
    }
  }

  dispatchVariantChangeEvent(newDocument, sectionId, variantId) {
    const event = new CustomEvent('variant:changed', {
      bubbles: true,
      detail: {
        html: newDocument,
        sectionId: sectionId,
        variant: this.getSelectedVariantData(newDocument),
        variantId: variantId
      }
    });
    this.dispatchEvent(event);
  }

  onVariantChanged(detail) {
    if (detail.variant && detail.variant.optionValues) {
      this.buttons.forEach((button, index) => {
        const value = detail.variant.optionValues[index];
        const textElement = button.querySelector('[data-option-text]');
        if (textElement) {
          textElement.textContent = value;
        }

        // Update color when variant changes
      });
    }
  }

  updateButtonsAndDropdowns(variantValues) {
    this.buttons.forEach((button, index) => {
      const selectedValue = variantValues[index]?.trim();
      if (!selectedValue) return;

      // Update button text
      const textElement = button.querySelector('[data-option-text]');
      if (textElement) {
        textElement.textContent = selectedValue;
      }

      // Update color if exists
      const colorElement = button.querySelector('[data-color]');

      // Update dropdown options
      const dropdown = button.nextElementSibling;
      const options = dropdown.querySelectorAll('.variant-selector__option');
      options.forEach(option => {
        const value = option.getAttribute('data-value');

        // Update option color
        const optionColorElement = option.querySelector('[data-color-value]');

        // Update selected state
        if (value === selectedValue) {
          option.classList.add('selected');
        } else {
          option.classList.remove('selected');
        }
      });
    });
  }
}



customElements.define('variant-selectors', VariantSelectors);
